import { openModal } from "./modal";

export function showConfirmModal(message: string, confirmLabel: string): Promise<boolean> {
  return new Promise((resolve) => {
    const content = document.createElement("div");
    content.innerHTML = `
      <h2>Confirmer</h2>
      <p>${message}</p>
      <div class="menu-actions">
        <button class="btn btn-primary" id="confirm-yes" type="button">${confirmLabel}</button>
        <button class="btn btn-ghost" id="confirm-no" type="button">Annuler</button>
      </div>
    `;
    const { close } = openModal(content, { dismissible: false });
    content.querySelector<HTMLButtonElement>("#confirm-yes")?.addEventListener("click", () => {
      close();
      resolve(true);
    });
    content.querySelector<HTMLButtonElement>("#confirm-no")?.addEventListener("click", () => {
      close();
      resolve(false);
    });
  });
}
